import * as service from './service'
export default {
  namespace: 'customerServiceAppealDetail',
  state: {},
  effects: {
    * queryCsAppealDetail ({ payload }, { call, put }) {
      const res = yield call(service.queryCsAppealDetail, payload)
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
